import type { FC } from 'react';

// @ts-expect-error - SelectResourceFileOrUrl does not have types
import { SelectResourceFileOrUrl } from 'src/components/SelectResourceFileOrUrl';
import { type Resource, type ResourceContentType } from 'src/data/performance';
import type { Callback } from 'src/lib/types';

import { useVisibleResources } from './services/useVisibleResources';
import { useHandlers } from './useHandlers';

interface Props {
  className?: string;
  selectedResource?: Resource;
  onSelect: Callback<Resource | undefined>;
  onInputChange?: Callback<string>;
  placeholder?: string;
  displayResourceTypes: ResourceContentType[];
  allowedFileTypes?: string[];
  eventPage?: string;
}

export const SelectResourceForm: FC<Props> = ({
  className,
  selectedResource,
  onSelect,
  onInputChange,
  placeholder = '',
  displayResourceTypes,
  allowedFileTypes,
  eventPage,
}) => {
  const resources = useVisibleResources({ displayResourceTypes, allowedFileTypes });
  const { handleSelect, handleAddResource } = useHandlers({
    eventPage,
    allowedFileTypes,
    onSelect,
  });

  return (
    <SelectResourceFileOrUrl
      className={className}
      resources={resources}
      selectedResource={selectedResource}
      onSelect={handleSelect}
      onAddResource={handleAddResource}
      onInputChange={onInputChange}
      placeholder={placeholder}
    />
  );
};
